module.exports = __webpack_public_path__ + "static/media/Search.a44d813c.svg";